<div class="card documento-repositorio-container">
    <p-toolbar styleClass="mb-4 documento-repositorio-header">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo"
                icon="pi pi-plus" class="p-button-success mr-2"
                [disabled]="permissaoService.can('documentos_inserir') == false"
                (click)="abrirModalNovoDocumento()"></button>
        </ng-template>
    </p-toolbar>

    <div class="documento-repositorio-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loading"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id', 'descricao', 'tipo_documento_descricao', 'vinculo_nome', 'vinculo_nome_exibicao', 'clientes_nomes']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between p-flex-wrap">
                <div class="flex align-items-center p-flex-wrap">
                    <h5 class="p-m-0 mr-3">Repositório de Documentos</h5>
                </div>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Código</th>
                <th>Tipo</th>
                <th>Estação/Cliente</th>
                <th>Descrição</th>
                <th>Quant. documentos</th>
                <th class="col-acoes" style="width: 18%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr style="cursor: pointer;" (click)="abrirModalDocumentos(item)">
                <td><span class="p-column-title negrito">Código: </span>{{item.id}}</td>
                <td>
                    <span class="p-column-title negrito">Tipo: </span>
                    <i [class]="item.tipo_documento === 0 ? 'pi pi-map-marker' : 'pi pi-building'"
                       [style]="{'font-size': '1.2rem', 'color': item.tipo_documento === 0 ? '#2196F3' : '#FF9800', 'margin-right': '0.5rem'}"></i>
                    <span>{{item.tipo_documento_descricao}}</span>
                </td>
                <td>
                    <span class="p-column-title negrito">Estação/Cliente: </span>
                    <span class="vinculo-resumo"
                        [pTooltip]="obterTooltipVinculo(item)"
                        tooltipPosition="top">
                        {{ item.vinculo_nome_exibicao || formatarVinculo(item) }}
                    </span>
                </td>
                <td><span class="p-column-title negrito">Descrição: </span>{{item.descricao}}</td>
                <td>
                    <span class="p-column-title negrito">Quant. documentos: </span>
                    <span class="p-badge p-badge-info">{{item.quantidade_documentos}} documento{{item.quantidade_documentos !== 1 ? 's' : ''}}</span>
                </td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple type="button" icon="pi pi-eye"
                        class="p-button-rounded p-button-info mr-2"
                        pTooltip="Visualizar documentos" tooltipPosition="top"
                        (click)="abrirModalDocumentos(item); $event.stopPropagation()"></button>
                    <button pButton pRipple type="button" icon="pi pi-pencil"
                        class="p-button-rounded p-button-primary"
                        pTooltip="Editar repositório de documentos" tooltipPosition="top"
                        [disabled]="permissaoService.can('documentos_editar') == false"
                        (click)="editarDocumento(item); $event.stopPropagation()"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" style="text-align: center;">Nenhum documento de repositório encontrado.</td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<!-- Dialog: Novo Documento / Editar Documento -->
<p-dialog
    [header]="editandoDocumentoId ? 'Editar Documento' : 'Novo Documento'"
    [(visible)]="novoDocumentoModal"
    [modal]="true"
    [style]="{width: '50vw', maxWidth: '620px'}"
    [contentStyle]="{'padding': '1.5rem 1.75rem', 'min-height': '310px'}"
    [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true"
    (onHide)="fecharModalNovoDocumento()">

    <div class="form-dialog-body">
        <div class="form-context-hint mb-4">
            <i [class]="'pi ' + (editandoDocumentoId ? 'pi-pencil' : 'pi-folder-open')"></i>
            <span>{{ editandoDocumentoId
                ? 'Atualize os dados do repositório de documentos.'
                : 'Preencha os dados para criar um novo repositório de documentos.' }}</span>
        </div>

        <div class="p-fluid">
            <div class="form-field">
                <label for="tipo_documento_upload" class="form-label">
                    Tipo de Vínculo <span class="label-required">*</span>
                </label>
                <p-dropdown
                    inputId="tipo_documento_upload"
                    [options]="dropDownTipoDocumento"
                    [(ngModel)]="tipoDocumento"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onTipoDocumentoChange()"
                    [showClear]="true"
                    placeholder="Selecione o tipo">
                </p-dropdown>
            </div>

            <div class="form-field" *ngIf="tipoDocumento === 0">
                <label for="estacao_upload" class="form-label">
                    Estação <span class="label-required">*</span>
                </label>
                <p-dropdown
                    inputId="estacao_upload"
                    [options]="dropDownEstacoes"
                    [(ngModel)]="estacaoSelecionadaParaUpload"
                    [filter]="true"
                    filterLocale="pt-BR"
                    filterPlaceholder="Pesquisar estação..."
                    [showClear]="true"
                    placeholder="Selecione a estação">
                </p-dropdown>
            </div>

            <div class="form-field" *ngIf="tipoDocumento === 1">
                <label for="cliente_upload" class="form-label">
                    Clientes <span class="label-required">*</span>
                </label>
                <p-multiSelect
                    inputId="cliente_upload"
                    [options]="dropDownClientes"
                    [(ngModel)]="clientesSelecionadosParaUpload"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterLocale="pt-BR"
                    filterPlaceholder="Pesquisar cliente..."
                    appendTo="body"
                    scrollHeight="min(45vh, 22rem)"
                    panelStyleClass="clientes-multiselect-panel"
                    [showClear]="true"
                    (onClear)="limparClientesSelecionados()"
                    [showToggleAll]="false"
                    (onChange)="onClientesChange($event)"
                    [maxSelectedLabels]="1"
                    selectedItemsLabel="{0} clientes selecionados"
                    placeholder="Selecione um ou mais clientes"
                    styleClass="clientes-multiselect">
                </p-multiSelect>
            </div>

            <div class="form-field">
                <label for="descricao_upload" class="form-label">
                    Descrição <span class="label-required">*</span>
                </label>
                <textarea
                    id="descricao_upload"
                    pTextarea
                    [(ngModel)]="descricaoNovoDocumento"
                    rows="3"
                    placeholder="Descreva o repositório de documentos...">
                </textarea>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer-actions">
            <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-outlined p-button-secondary"
                (click)="fecharModalNovoDocumento()"></button>
            <button pButton pRipple type="button"
                [label]="salvandoDocumento ? 'Salvando...' : (editandoDocumentoId ? 'Atualizar' : 'Salvar')"
                [icon]="editandoDocumentoId ? 'pi pi-save' : 'pi pi-check'"
                class="p-button-success"
                [disabled]="salvandoDocumento"
                (click)="salvarNovoDocumento()"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog: Novo Arquivo -->
<p-dialog
    header="Novo Arquivo"
    [(visible)]="novoArquivoModal"
    [modal]="true"
    [style]="{width: '50vw', maxWidth: '620px'}"
    [contentStyle]="{'padding': '1.5rem 1.75rem', 'min-height': '360px'}"
    [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true"
    (onHide)="fecharModalNovoArquivo()">

    <div class="form-dialog-body">
        <div class="form-context-hint mb-4">
            <i class="pi pi-upload"></i>
            <span>Selecione e envie um arquivo para vincular ao documento.</span>
        </div>

        <div class="p-fluid">
            <div class="form-field">
                <label class="form-label">Documento de destino</label>
                <div class="destino-badge">
                    <i class="pi pi-folder mr-2"></i>
                    <span>{{ vinculoSelecionado?.descricao || '—' }}</span>
                </div>
            </div>

            <div class="form-field">
                <label for="descricao_arquivo_upload" class="form-label">Descrição do arquivo</label>
                <textarea
                    id="descricao_arquivo_upload"
                    pTextarea
                    [(ngModel)]="descricaoNovoArquivo"
                    rows="2"
                    placeholder="Breve descrição sobre o arquivo (opcional)...">
                </textarea>
            </div>

            <div class="form-field">
                <label class="form-label">Arquivo <span class="label-required">*</span></label>
                <p-fileUpload #uploadArquivoFilho name="arquivo"
                    [showUploadButton]="false" [showCancelButton]="false" [multiple]="false"
                    [customUpload]="true" chooseLabel="Selecionar Arquivo" chooseIcon="pi pi-paperclip"
                    [maxFileSize]="524288000"
                    (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove()"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.bmp,.webp">
                    <ng-template pTemplate="content">
                        <div *ngIf="arquivoSelecionadoUpload" class="arquivo-escolhido">
                            <i class="pi pi-check-circle mr-2"></i>
                            <span>{{ arquivoSelecionadoUpload.name }}</span>
                        </div>
                    </ng-template>
                </p-fileUpload>
                <small class="form-hint">Formatos aceitos: PDF, Word, Excel, PNG, JPG, BMP, WebP</small>
            </div>

            <div class="form-field" *ngIf="uploadingArquivo">
                <div class="flex align-items-center justify-content-between mb-2">
                    <label class="form-label mb-0">Enviando arquivo</label>
                    <span>{{ uploadArquivoProgress | number:'1.0-0' }}%</span>
                </div>
                <p-progressBar [value]="uploadArquivoProgress"></p-progressBar>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer-actions">
            <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-outlined p-button-secondary"
                (click)="fecharModalNovoArquivo()"></button>
            <button pButton pRipple type="button"
                [label]="uploadingArquivo ? 'Enviando...' : 'Enviar Arquivo'"
                icon="pi pi-upload"
                class="p-button-success"
                [disabled]="uploadingArquivo"
                (click)="salvarNovoArquivo()"></button>
        </div>
    </ng-template>
</p-dialog>

<!-- Dialog: Lista de Arquivos -->
<p-dialog
    [header]="vinculoSelecionado ? 'Arquivos — ' + vinculoSelecionado.descricao : 'Arquivos'"
    [(visible)]="modalDocumentos"
    [modal]="true"
    [style]="{width: '90vw', maxWidth: '1000px', height: '78vh'}"
    [contentStyle]="{'padding': '0', 'overflow': 'hidden', 'height': 'calc(78vh - 130px)', 'display': 'flex', 'flex-direction': 'column'}"
    [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true"
    (onHide)="modalDocumentos = false; vinculoSelecionado = null; documentosVinculo = []">

    <!-- Barra de contexto e ação -->
    <div class="arquivos-dialog-topbar" *ngIf="vinculoSelecionado">
        <div class="arquivos-meta">
            <i [class]="'pi mr-2 ' + (vinculoSelecionado.tipo_documento === 0 ? 'pi-map-marker' : 'pi-building')"
               [style]="{'color': vinculoSelecionado.tipo_documento === 0 ? '#2196F3' : '#FF9800'}"></i>
            <span class="font-semibold mr-3"
                [pTooltip]="obterTooltipVinculo(vinculoSelecionado)"
                tooltipPosition="top">
                {{ vinculoSelecionado.vinculo_nome_exibicao || formatarVinculo(vinculoSelecionado) }}
            </span>
            <span class="arquivos-count-badge" *ngIf="!loadingDocumentos">
                {{ documentosVinculo.length }} arquivo{{ documentosVinculo.length !== 1 ? 's' : '' }}
            </span>
        </div>
        <button pButton pRipple type="button" label="Novo Arquivo" icon="pi pi-plus"
            class="p-button-success p-button-sm"
            [disabled]="permissaoService.can('documentos_inserir') == false"
            (click)="abrirModalNovoArquivo()">
        </button>
    </div>

    <!-- Estado de carregamento -->
    <div *ngIf="loadingDocumentos" class="arquivos-state-view">
        <p-progressSpinner [style]="{width: '48px', height: '48px'}" strokeWidth="6" animationDuration=".5s"></p-progressSpinner>
        <span class="mt-3">Carregando arquivos...</span>
    </div>

    <!-- Estado vazio -->
    <div *ngIf="!loadingDocumentos && documentosVinculo.length === 0" class="arquivos-state-view">
        <i class="pi pi-inbox" style="font-size: 3.5rem; color: #ccc;"></i>
        <p class="mt-2 mb-3" style="color: var(--text-color-secondary)">Nenhum arquivo encontrado para este documento.</p>
        <button pButton pRipple type="button" label="Adicionar Arquivo" icon="pi pi-upload"
            class="p-button-outlined p-button-success"
            [disabled]="permissaoService.can('documentos_inserir') == false"
            (click)="abrirModalNovoArquivo()">
        </button>
    </div>

    <!-- Lista de arquivos -->
    <div *ngIf="!loadingDocumentos && documentosVinculo.length > 0" class="arquivos-scroll-area">
        <div class="arquivos-grid">
            <div *ngFor="let documento of documentosVinculo" class="arquivo-card">
                <div class="arquivo-card-icon">
                    <i [class]="'pi ' + getFileIcon(documento)"></i>
                </div>
                <div class="arquivo-card-body">
                    <div class="arquivo-card-nome">{{ documento.nome }}</div>
                    <div class="arquivo-card-meta">
                        <span *ngIf="documento.descricao">{{ documento.descricao }}</span>
                        <span>{{ formatarTamanho(documento.tamanho) }}</span>
                        <span *ngIf="documento.created_at">{{ documento.created_at | date:'dd/MM/yyyy' }}</span>
                    </div>
                </div>
                <div class="arquivo-card-acoes">
                    <button *ngIf="podeVisualizar(documento)"
                        pButton pRipple type="button"
                        icon="pi pi-eye"
                        class="p-button-rounded p-button-info p-button-sm"
                        pTooltip="Visualizar" tooltipPosition="top"
                        (click)="abrirPreview(documento)">
                    </button>
                    <button pButton pRipple type="button"
                        icon="pi pi-download"
                        class="p-button-rounded p-button-success p-button-sm"
                        pTooltip="Download" tooltipPosition="top"
                        (click)="downloadDocumento(documento)">
                    </button>
                </div>
            </div>
        </div>
    </div>
</p-dialog>

<!-- Dialog: Preview de Documento -->
<p-dialog
    [header]="documentoPreview ? 'Visualizar — ' + documentoPreview.nome : 'Visualizar Documento'"
    [(visible)]="modalPreview"
    [modal]="true"
    [style]="{width: '90vw', maxWidth: '1200px', height: '90vh'}"
    [draggable]="false" [resizable]="true" [closable]="true"
    [dismissableMask]="true"
    (onHide)="fecharPreview()">

    <div *ngIf="documentoPreview" class="preview-container">
        <iframe *ngIf="podeVisualizar(documentoPreview)"
            [src]="getPreviewUrl(documentoPreview)"
            style="width: 100%; height: calc(90vh - 100px); border: none;">
        </iframe>
        <div *ngIf="!podeVisualizar(documentoPreview)" class="arquivos-state-view">
            <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #ff9800;"></i>
            <p class="mt-3">Este tipo de arquivo não pode ser visualizado. Use o botão de download.</p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button"
            icon="pi pi-download"
            label="Download"
            class="p-button-success"
            (click)="downloadDocumento(documentoPreview)">
        </button>
        <button pButton pRipple type="button"
            label="Fechar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="fecharPreview()">
        </button>
    </ng-template>
</p-dialog>
